import React from 'react';
import BreadCrumbs from '../../../components/common/breadcrumbs/BreadCrumbs';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';

const BreadcrumbsContainer = ({title, icon}) => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);
  const titlenames = title.split('/').filter((x) => x);

  return <Box sx={{
      // [해결] 모바일(xs)에서는 글자 크기를 줄이고, 데스크탑(md) 이상에선 기본 크기 유지
      '& .MuiTypography-root, & .MuiBreadcrumbs-li': {
        fontSize: { xs: '0.75rem', md: '0.875rem' }, // 모바일 12px, 데스크탑 14px 예시
      },
      '& svg': {
        fontSize: { xs: '1rem', md: '1.25rem' } // 아이콘 크기도 함께 조정
      },
    }}>
      <BreadCrumbs pathnames={pathnames} titlenames={titlenames} icon={icon}/>
    </Box>
};

export default BreadcrumbsContainer;
